import { Newsletter } from './pages';

export default {
  key: 'newsletter',
  isPrivate: true,
  exact: true,
  path: '/schools/:sid/school-newsletters/:nid',
  component: Newsletter,
};
